<div *ngIf="ticketReservation">
    <h5>
        {{ 'save-take-code-to-appointment' | translate }}:
        <span class="text-primary">{{ ticketReservation?.code ?? "" }}</span>
    </h5>
    <div class="alert alert-info my-2">
        <i class="fas fa-info-circle"></i>
        {{ 'necessary-code' | translate }}. {{ 'schedule-time' | translate }}.
    </div>
    <div>{{ 'your-reserved-ticket' | translate }}:</div>
    <div>{{ 'category' | translate }}: <span class="text-primary font-weight-bold">{{ categoryName }}</span></div>
    <div>{{ 'date' | translate }}:
        <span class="text-primary font-weight-bold">
            {{ displayReservationTime | date:'dd/MM/yyyy HH:mm':'UTC' }}
        </span>
    </div>
    <button class="btn btn-danger" data-toggle="modal" data-target="#confirmDeleteModal"
        (click)="openDeleteReservationPopup()">{{ 'reservation-cancel' | translate }}</button>
</div>
<div *ngIf="!ticketReservation">
    <h5 *ngIf="!ticketReservationDeleted">{{ 'reservation-does-not-exist' | translate }}</h5>
    <h5 *ngIf="ticketReservationDeleted">{{ 'reservation-deleted' | translate }}</h5>
</div>